export enum SelectionItemEvent {
  REMOVE = 'selection-item-remove',
  REMOVE_LOADER = 'selection-item-remove-loader',
  ARCHIVE_PROPOSAL = 'selection-item-archive-proposal',
  ADD_PROPOSAL = 'selection-item-add-proposal',
}

export enum Slider {
  CREATE_PROPOSAL = 'offer-proposal',
  REFUSE_SELECTION_ITEM = 'refuse-selection-item',
}
